const AudiosHome = () => import(/* webpackChunkName: "group-pabx-cadastros-audios" */ '../_views/AudiosHome')
const CadastroAudio = () => import(/* webpackChunkName: "group-pabx-cadastros-audios" */ '../_views/CadastroAudio')

import { permissionsPabx } from '../../../../../utils/permissionsPabx'

export default [
  {
    path: 'audios',
    component: AudiosHome,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'Audios',
  },
  {
    path: 'audios/criar',
    component: CadastroAudio,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'Audios/criar',
  },
]
